import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL_SERVER } from "../api/api";
import { AuthContext } from "../context/AuthContext";

const ManageAccounts = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Redirect if not admin
  useEffect(() => {
    if (user && user.role !== "admin") {
      toast.error("You are not authorized to view this page.");
      navigate("/"); // Or navigate to accounts page
    }
  }, [user, navigate]);

  // Fetch all accounts (visible and hidden)
  const fetchAllAccounts = async () => {
    setLoading(true);
    try {
      // **IMPORTANT:** This needs a new backend endpoint
      // You must create this endpoint: GET /api/accounts/all
      const response = await axios.get(`${API_URL_SERVER}/accounts/all`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setAccounts(response.data);
    } catch (error) {
      toast.error(
        error.response?.data?.error || "Failed to fetch all accounts"
      );
      console.error("Fetch all accounts error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && user.role === "admin") {
      fetchAllAccounts();
    }
  }, [user]);

  const handleVisibilityChange = async (
    accountId,
    strategy,
    currentIsHidden
  ) => {
    const newIsHidden = !currentIsHidden;
    try {
      // **IMPORTANT:** This needs a new backend endpoint
      // You must create this endpoint: PUT /api/accounts/visibility
      await axios.put(
        `${API_URL_SERVER}/accounts/visibility`,
        {
          accountId: accountId,
          strategy: strategy,
          is_hidden: newIsHidden,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Update state locally for instant feedback
      setAccounts((prevAccounts) =>
        prevAccounts.map((acc) =>
          acc.mt5AccountId === accountId && acc.strategy === strategy
            ? { ...acc, is_hidden: newIsHidden }
            : acc
        )
      );
      toast.success(
        `Account ${newIsHidden ? "hidden" : "made visible"}`
      );
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update visibility"
      );
    }
  };

  if (loading) {
    return <h3 className="text-center mt-5">Loading Accounts...</h3>;
  }

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">Manage Accounts</h1>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>No.</th>
              <th>Login ID</th>
              <th>Nickname</th>
              <th>Strategy</th>
              <th>Show on Main Page (Visible)</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((account, index) => (
              <tr
                key={`${account.mt5AccountId}:${account.strategy}`}
                className={account.is_hidden ? "table-secondary" : ""}
              >
                <td>{index + 1}</td>
                <td>{account.mt5AccountId}</td>
                <td>{account.nickName}</td>
                <td>{account.strategy}</td>
                <td>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={`switch-${account.mt5AccountId}-${account.strategy}`}
                      checked={!account.is_hidden} // Checkbox is "checked" if it's NOT hidden
                      onChange={() =>
                        handleVisibilityChange(
                          account.mt5AccountId,
                          account.strategy,
                          account.is_hidden
                        )
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`switch-${account.mt5AccountId}-${account.strategy}`}
                    >
                      {account.is_hidden ? "Hidden" : "Visible"}
                    </label>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageAccounts;